import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  searchResult: undefined,
  searchResultDnaHistorical: undefined,
  searchResultImports: undefined,
  searchResultImportHistory: undefined,
  details: {
    generalInformation: undefined,
    companyData: undefined,
    networkData: undefined,
    directTeam: undefined,
  },
  newConsultantSidebar: {
    id: undefined,
    customer_id: undefined,
    approval_date: undefined,
    visible: false,
  },
  newEmployeeSidebar: {
    id: undefined,
    affiliationType: undefined,
    visible: false,
    saveAction: undefined,
  },
  changeConsultantRoleSidebar: {
    id: undefined,
    name: undefined,
    role: undefined,
    roleId: undefined,
    roleDepth: undefined,
    contractType: undefined,
    visible: false,
    saveAction: undefined,
  },
  changePhysicalFranchiseSidebar: {
    id: undefined,
    physicalFranchiseId: undefined,
    visible: false,
    saveAction: undefined,
  },
  transferredConsultants: [],
  transferableConsultants: [],
  affiliationTypes: [],
  importEadSidebar: {
    visible: false,
    saveAction: undefined,
  },
  pendingPromotionSteps: [],
  appointmentClosureRates: {},
  indicatorsSummary: {},
  qualitativeHighlights: [],
  consultantCertificateSidebar: {
    visible: false,
    saveAction: undefined
  },
  certificateTypes: [],
  consultantTerminationReasons: [],
  promotionContractRules: [],
  rolePromotionSidebar: {
    id: undefined,
    visible: false,
    saveAction: undefined,
  },
  rolePromotionSearchResult: undefined,
  rolePromotionStatusTypes: [],
  pns_pending_onboarding: [],
}

export default {
  state,
  actions,
  getters,
  mutations,
};
